<page-heading
  [title]="isNew ? ('agents.trendgptForm.titleCreate' | translate) : ('agents.trendgptForm.titleEdit' | translate)"
  [description]="
    isNew
      ? ('agents.trendgptForm.descriptionCreate' | translate)
      : ('agents.trendgptForm.descriptionEdit' | translate)
  "
  [hasBreadcrumb]="true"
  [breadcrumb]="breadcrumb"
/>

<div class="tm-stepper mt-4 col-12 mx-auto">
  <div class="steps-wrapper position-relative">
    <div class="track w-100" aria-hidden="true"></div>
    <div
      class="progress-line"
      [style.width.%]="progressPct"
      aria-hidden="true"
    ></div>

    <div
      class="steps pt-3 d-flex flex-wrap justify-content-between mb-3 position-relative"
    >
      @for (step of steps; track $index;) {
        <div
          class="step d-flex align-items-center gap-2"
          [class.current]="$index + 1 === currentStep"
          [attr.aria-current]="$index + 1 === currentStep ? 'step' : null"
          (click)="stepIndex.set($index); $event.stopPropagation()"
        >
          <div class="badge-num d-flex align-items-center justify-content-center">
            @if ($index < stepIndex()) {
              <i class="mdi mdi-check fw-bold" aria-hidden="true"></i>
            } @else {
              <span>{{ $index + 1 }}</span>
            }
          </div>
          <div
            class="text-truncate cursor-pointer"
          >
            <div class="label text-truncate">{{ step.title | translate }}</div>
            <small class="text-muted text-truncate d-block">
              {{ step.subtitle | translate }}
            </small>
          </div>
        </div>
      }
    </div>
  </div>
</div>

<div class="row">
  <div class="col-12">
    <div class="card">
      <div class="card-body">
        <form [formGroup]="formGroup">
          @switch (stepIndex()) {
            @case (0) {
              <div>
                <h4>{{ 'agents.trendgptForm.basicInfoTitle' | translate }}</h4>
                <small>{{ 'agents.trendgptForm.basicInfoSubtitle' | translate }}</small>
              </div>

              <div class="row">
                <div class="card-body">
                  <div class="row">
                    <div class="col-md-8">
                      <label for="agentName" class="form-label fw-semibold">
                        {{ 'agents.trendgptForm.agentNameLabel' | translate }}
                      </label>
                      <input
                        type="text"
                        id="agentName"
                        class="form-control"
                        formControlName="name"
                        [placeholder]="'agents.trendgptForm.agentNamePlaceholder' | translate"
                      />
                    </div>
                    <div class="col-md-4">
                      <label class="form-label fw-semibold">
                        {{ 'agents.trendgptForm.channelsLabel' | translate }}
                      </label>
                      <mat-select
                        #ChannelSel
                        class="form-select"
                        formControlName="channels"
                        multiple
                        [placeholder]="'agents.trendgptForm.channelsPlaceholder' | translate"
                      >
                        <mat-option value="" disabled>{{ 'agents.trendgptForm.channelsSelectOption' | translate }}</mat-option>
                        @for(channel of listChannel; track $index ) {
                        <mat-option [value]="channel._id">{{
                          channel.name
                        }}</mat-option>
                        }
                      </mat-select>
                      <field-error-component
                        [field]="'channels'"
                        [label]="'agents.trendgptForm.channelsErrorLabel' | translate"
                        [formGroup]="formGroup"
                      ></field-error-component>
                    </div>
                  </div>

                  <div class="mt-3">
                    <label for="agentPurpose" class="form-label fw-semibold">
                      {{ 'agents.trendgptForm.agentPurposeLabel' | translate }}
                    </label>
                    <div class="px-3 d-flex gap-3 align-items-center justify-content-center">
                      @for(type of agentTypes; track $index) {
                        <div
                          class="card-hover border py-1 rounded col-xs-12 col-lg-4 flex-column d-flex align-items-center cursor-pointer"
                          role="radio"
                          tabindex="0"
                          (click)="handleSelectAgentType(type.value)"
                          [ngClass]="{
                            'border-primary': isSelectedType(type.value),
                          }"
                        >
                          <div class="avatar-md">
                            <span class="avatar-title bg-info-subtle rounded-circle">
                                <i class="{{type.icon}} fs-1 text-primary"></i>
                            </span>
                          </div>
                          <div class="text-center">
                            <h4>{{ type.label | translate }}</h4>
                            <small>{{ type.subtitle | translate }}</small>
                          </div>
                        </div>
                      }
                    </div>
                  </div>

                  <div class="col-12">
                    <label for="product" class="form-label fw-semibold mt-3">
                      {{ 'agents.trendgptForm.productLabel' | translate }}
                    </label>
                    <input
                      type="text"
                      id="product"
                      class="form-control"
                      formControlName="jobName"
                      [placeholder]="'agents.trendgptForm.productPlaceholder' | translate"
                    />
                  </div>

                  <div class="col-12">
                    <label for="site" class="form-label fw-semibold mt-3">
                      {{ 'agents.trendgptForm.officialSiteLabel' | translate }}
                    </label>
                    <input
                      type="text"
                      id="site"
                      class="form-control"
                      formControlName="jobSite"
                      [placeholder]="'agents.trendgptForm.officialSitePlaceholder' | translate"
                    />
                  </div>

                  <div class="col-12">
                    <label for="agentDescription" class="form-label fw-semibold mt-3">
                    {{ 'agents.trendgptForm.agentDescriptionLabel' | translate }}
                    </label>
                    <textarea
                    id="agentDescription"
                    #agentDescriptionInput
                    class="form-control"
                    formControlName="jobDescription"
                    rows="4"
                    maxlength="500"
                    style="resize: none;"
                    [placeholder]="'agents.trendgptForm.agentDescriptionPlaceholder' | translate"
                    ></textarea>
                    <div class="text-end">
                    <small class="text-muted">
                      {{ (agentDescriptionInput.value?.length || 0) }}/500
                    </small>
                    </div>
                  </div>
                </div>
              </div>
            }

            @case (1) {
              <div>
                <h4>{{ 'agents.trendgptForm.personalityTitle' | translate }}</h4>
                <small>{{ 'agents.trendgptForm.personalitySubtitle' | translate }}</small>
              </div>

              <div class="mt-3">
                <label for="agentPurpose" class="form-label fw-semibold">
                  {{ 'agents.trendgptForm.communicationLabel' | translate }}
                </label>
                <div class="px-3 d-flex gap-3 align-items-center justify-content-center">
                  @for(comunicationType of comunicationTypes; track $index) {
                    <div
                      class="card-hover border py-1 rounded col-xs-12 col-lg-4 flex-column text-center cursor-pointer"
                      role="radio"
                      tabindex="0"
                      (click)="handleSelectCommunicationType(comunicationType.value)"
                      [ngClass]="{
                        'active': isSelectedCommunicationType(comunicationType.value),
                        'border-primary': isSelectedCommunicationType(comunicationType.value),
                      }"
                    >
                      <div class="text-center">
                        <h4>{{ comunicationType.label | translate }}</h4>
                        <small>{{ comunicationType.subtitle | translate }}</small>
                      </div>
                    </div>
                  }
                </div>
              </div>

              <div class="col-12">
                <label for="agentBehavior" class="form-label fw-semibold mt-3">
                {{ 'agents.trendgptForm.agentBehaviorLabel' | translate }}
                </label>
                <textarea
                id="agentBehavior"
                #agentBehaviorInput
                class="form-control"
                formControlName="behavior"
                rows="4"
                maxlength="3000"
                style="resize: none;"
                [placeholder]="'agents.trendgptForm.agentBehaviorPlaceholder' | translate"
                ></textarea>
                <div class="text-end">
                  <small class="text-muted">
                    {{ (agentBehaviorInput.value?.length ?? 0) }}/3000
                  </small>
                </div>
              </div>

            }

            @case (2) {
              <app-agent-training-form
                [agentId]="currentAgentId"
                [currentStep]="currentStep"
                (saveAndNext)="saveAndNextStep()"
              />
            }

            @case (3) {
              <app-agent-intentions-form
                [agentId]="currentAgentId"
                [channelRef]="channelRef"
              />
            }

            @case (4) {
              <app-agent-configs-form
                (previousStep)="previousStep()"
                [agentId]="currentAgentId"
              />
            }
          }
        </form>
      </div>
    </div>
  </div>

  <div class="d-flex gap-2 mb-3">
    <button
      class="d-flex align-items-center gap-2 btn btn-outline-secondary rounded fw-semibold"
      (click)="previousStep()"
      [disabled]="stepIndex() === 0"
    >
      <i class="mdi mdi-arrow-left-thin"></i>
      {{ 'agents.trendgptForm.backButton' | translate }}
    </button>
    
    @switch (stepIndex()) {
      @case (1) {
        <button
          class="d-flex align-items-center gap-2 btn btn-primary ms-auto rounded fw-semibold"
          (click)="saveAndNextStep()"
          [disabled]="loading"
        >
          @if (loading) {
            <span class="spinner-border spinner-border-sm me-1"></span>
          }
          {{ 'agents.trendgptForm.saveAndNextButton' | translate }}
          <i class="mdi mdi-arrow-right-thin"></i>
        </button>
      }
      @case (4) {
        <button
          class="d-flex align-items-center gap-2 btn btn-success ms-auto rounded fw-semibold"
          (click)="saveConfigs()"
          [disabled]="loading"
        >
          @if (loading) {
            <span class="spinner-border spinner-border-sm me-1"></span>
          }
          {{ 'agents.trendgptForm.saveConfigsButton' | translate }}
          <i class="mdi mdi-check"></i>
        </button>
      }
      @default {
        <button
          class="d-flex align-items-center gap-2 btn btn-primary ms-auto rounded fw-semibold"
          (click)="nextStep()"
          [disabled]="stepIndex() === steps.length - 1"
        >
          {{ 'agents.trendgptForm.nextButton' | translate }}
          <i class="mdi mdi-arrow-right-thin"></i>
        </button>
      }
    }
  </div>
</div>
